export type UserRole = "admin" | "supervisor" | "office" | "foreman" | "viewer";

export const MAP_ROLES: UserRole[] = ["admin", "supervisor", "office"];
export const FIELD_ROLES: UserRole[] = ["foreman", "viewer"];
export const APPROVER_ROLES: UserRole[] = ["admin", "supervisor", "office"];

export function isUserRole(value: string | null | undefined): value is UserRole {
  return (
    value === "admin" ||
    value === "supervisor" ||
    value === "office" ||
    value === "foreman" ||
    value === "viewer"
  );
}

export function isMapRole(value: string | null | undefined): value is UserRole {
  return isUserRole(value) && MAP_ROLES.includes(value);
}

export function isFieldRole(value: string | null | undefined): value is UserRole {
  return isUserRole(value) && FIELD_ROLES.includes(value);
}

export function isApproverRole(value: string | null | undefined): value is UserRole {
  return isUserRole(value) && APPROVER_ROLES.includes(value);
}

export function canCreateJobCard(value: string | null | undefined): boolean {
  return value === "admin" || value === "supervisor" || value === "office" || value === "foreman";
}

export function canCreateConsultation(value: string | null | undefined): boolean {
  return value === "admin" || value === "supervisor" || value === "office";
}

export function canAccessConsultations(value: string | null | undefined): boolean {
  return value === "admin" || value === "supervisor" || value === "office";
}

export function canAccessPipeline(value: string | null | undefined): boolean {
  return value === "admin" || value === "supervisor";
}

export function getDefaultRouteForRole(value: string | null | undefined): string {
  if (isFieldRole(value)) {
    return "/field-home";
  }

  return "/app";
}
